export default {
  title: {
    auditLogManagement: 'Audit Logs'
  },
  menu: 'Audit Logs',
  label: {
    companyName: 'Company',
    operation: 'Operation',
    detail: 'Detail',
    operator: 'Operator',
    operateTime: 'Operate Time'
  },
  placeholder: {
    operation: 'Select Operation Type'
  },
  logType: {
    USER_MANAGEMENT: 'User Management',
    ROLE_MANAGEMENT: 'Role Management'
  },
  operation: {
    CREATE_HR: 'Create HR',
    DISABLE_HR: 'Disable HR',
    ENABLE_HR: 'Enable HR',
    EDIT_HR: 'Edit HR',
    ASSIGN_ROLE: 'Assign Role To HR',
    REMOVE_ROLE: 'Remove Role From HR',
    CREATE_ROLE: 'Create Role',
    DELETE_ROLE: 'Delete Role',
    EDIT_ROLE: 'Edit Role'
  }
}
